export const profile = {
  bg: 'https://college-official.oss-cn-hangzhou.aliyuncs.com/materials/project/local/local-banner.png',
  bgMD: 'https://college-official.oss-cn-hangzhou.aliyuncs.com/materials/project/local/local-banner-MD.png',
  label: '地方服务',
  subLabel: 'Area-Focused Services',
  content:
    '根据地方需求、结合地方优势，学会广泛链接技术、人才等资源，通过地方服务站建设、人才帮扶项目等，积极服务浙江省内各地数字经济发展。',
};
